import PropTypes from 'prop-types';
import Currency from './Currency';
import './PropertyEstimateRange.scss';
import {Icon, Label} from 'semantic-ui-react';
import {Link} from '@mui/material';
import {getConfidenceFromAvm} from 'lib/AvmUtils';

PropertyEstimateRange.propTypes = {
  avm: PropTypes.object.isRequired,
  isRental: PropTypes.bool,
  onClick: PropTypes.func,
  onCopyToReport: PropTypes.func,
};

export default function PropertyEstimateRange({avm, isRental, onClick, onCopyToReport}) {
  const confidence = getConfidenceFromAvm(avm, isRental);
  const withConfidence = (confidence.label !== 'No');
  const onCopy = (event) => {
    onCopyToReport();
    event.stopPropagation();
  };

  return (
    <Label className="PropertyEstimateRange" attached="bottom right" size="large" onClick={ onClick } style={{backgroundColor: '#ccd6da', color: '#032636'}}>
      <div className="valuationLabel">
        <Icon name="info"/>
        Cotality valuation estimate
      </div>
      <div className="valuationRange">
        {
          withConfidence ? (
            <span className="valuationRange-available">
              <Currency currency={ avm.lowEstimate }/> - <Currency currency={ avm.highEstimate }/>
              <Icon name="circle" style={ {color: confidence.color, marginLeft: '0.4em'} }/>
            </span>
          ) : (
            <span className="valuationRange-not-available">not available</span>
          )
        }
      </div>
      {
        withConfidence && (
          <Link className="copy-report"
                onClick={ onCopy }
                component="button">
            Copy to report
          </Link>
        )
      }
    </Label>
  );
}